import {Component, OnDestroy, OnInit} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {ILengthAwarePaginator} from 'ng-rest-model';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import {Auth} from '../../auth/auth.service';
import {MessengerService} from '../../messenger/messenger.service';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';
import {Sermon} from '../classes/sermon';

@Component({
    selector: 'kkk-sermons',
    templateUrl: './sermons.component.html',
    styleUrls: ['./sermons.component.scss']
})
export class SermonsComponent implements OnInit, OnDestroy {

    pagination: ILengthAwarePaginator<Sermon>;
    pending: boolean = false;

    get sermons(): Sermon[] {
        return this.pagination && this.pagination.data;
    }

    private subscriptions: Subscription[] = [];

    constructor(
        public auth: Auth,
        private _breadcrumbs: BreadcrumbsService,
        private _messenger: MessengerService,
    ) {
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s && s.unsubscribe());
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Felvételek', instructions: ['/felvetelek']}).add({name: 'Tanítások'});
        this.loadPage();
        // this.subscriptions.push(this.handleObservable(new Sermon().all()));
    }

    loadPage(url?: string): void {
        this.pending = true;
        this.subscriptions.push(this.handleObservable(new Sermon().page(url)));
    }

    removeSermon(sermon: Sermon): void {
        if (confirm(`Biztosan törölni szeretnéd? ${sermon.date}, ${sermon.preacher}, ${sermon.title}`)) {
            this.subscriptions.push(
                sermon.remove().subscribe(() => this.pagination.data = this.pagination.data.filter(s => s.id !== sermon.id))
            );
        }
    }

    private handleObservable(obs: Observable<any>): Subscription {
        return obs.map(pagination => {
            this.pending = false;
            return pagination;
        })
                  .catch(e => {
                      this.pending = false;
                      throw e;
                  })
                  .subscribe(
                      pagination => this.pagination = pagination,
                      this._messenger.handleError
                  );
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/sermons/sermons.component.ts